export default {
  updateOptionsComment(state, val) {
    state.optionsComment = val;
  },

  // TODO: deprecated
  updateOptions(state, val) {
    state.optionsList[val.index].option_default = val.value;
  },

  updateOptionItemCustomizer(state, { name, code_1c, value }) {
    const index = state.optionsList.findIndex(el =>
      code_1c ? el.code_1c === code_1c : el.name === name,
    );

    if (index !== -1) {
      state.optionsList[index].option_default = value;
    }
  },

  updateIsDisabledDlypr(state, isVal = false) {
    state.isDisabledDlypr = isVal;
  },

  updateOptionsErrors(state, val) {
    if (val.inBasket !== undefined) {
      state.optionsErrors.inBasket = val.inBasket;
    }

    if (val.calculate !== undefined) {
      state.optionsErrors.calculate = val.calculate;
    }
  },

  updateOptionsList(state, val) {
    state.optionsList = val;
    state.optionsListOriginal = val;
  },

  updateOptionsListData(state, value) {
    state.optionsList = value;

  },
};
